import React from 'react'
import Image from 'next/image'
import { Container, Row } from 'react-bootstrap'
import MetalbookTeam1 from '@/assets/about-us/culture/01.webp'
import MetalbookTeam2 from '@/assets/about-us/culture/02.webp'
import MetalbookTeam3 from '@/assets/about-us/culture/03.webp'
import MetalbookTeam4 from '@/assets/about-us/culture/04.webp'
import MetalbookTeam5 from '@/assets/about-us/culture/05.webp'
import MetalbookTeam6 from '@/assets/about-us/culture/06.webp'
import MetalbookTeam7 from '@/assets/about-us/culture/07.webp'
import MetalbookTeam8 from '@/assets/about-us/culture/08.webp'
import MetalbookTeam9 from '@/assets/about-us/culture/09.webp'
import MetalbookTeam10 from '@/assets/about-us/culture/10.webp'
import MetalbookTeam11 from '@/assets/about-us/culture/11.webp'
import MetalbookTeam12 from '@/assets/about-us/culture/12.webp'
import MetalbookTeam13 from '@/assets/about-us/culture/13.webp'
import MetalbookTeam14 from '@/assets/about-us/culture/14.webp'
import MetalbookTeam15 from '@/assets/about-us/culture/15.webp'
import MetalbookTeam16 from '@/assets/about-us/culture/16.webp'
import MetalbookTeam17 from '@/assets/about-us/culture/17.webp'
import MetalbookTeam18 from '@/assets/about-us/culture/18.webp'
import MetalbookTeam19 from '@/assets/about-us/culture/19.webp'
import MetalbookTeam20 from '@/assets/about-us/culture/20.webp'
import MetalbookTeam21 from '@/assets/about-us/culture/21.webp'

const teamImgs = [
	MetalbookTeam1,
	MetalbookTeam2,
	MetalbookTeam3,
	MetalbookTeam4,
	MetalbookTeam5,
	MetalbookTeam6,
	MetalbookTeam7,
	MetalbookTeam8,
	MetalbookTeam9,
	MetalbookTeam10,
	MetalbookTeam11,
	MetalbookTeam12,
	MetalbookTeam13,
	MetalbookTeam14,
	MetalbookTeam15,
	MetalbookTeam16,
	MetalbookTeam17,
	MetalbookTeam18,
	MetalbookTeam19,
	MetalbookTeam20,
	MetalbookTeam21,
]

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/effect-creative'
import 'swiper/css/pagination'

// import './styles.css'

// import required modules
import { Autoplay, FreeMode } from 'swiper/modules'

const MeetMetalbookTeam = () => {
	return (
		<div className='meet-metalbook-team-container'>
			<h1 className='heading text-center'>Culture at Metalbook</h1>
			<Container>
				<Row className='g-2'>
					<Swiper
						spaceBetween={25}
						slidesOffsetAfter={0}
						slidesPerView={3}
						pagination={{
							clickable: true,
						}}
						autoplay={{
							delay: 1,
							disableOnInteraction: false,
						}}
						speed={3000}
						loop={true}
						breakpoints={{
							0: {
								slidesPerView: 1,
							},
							400: {
								slidesPerView: 1,
							},
							639: {
								slidesPerView: 3,
							},
							865: {
								slidesPerView: 3,
							},
							1000: {
								slidesPerView: 4,
							},
							1500: {
								slidesPerView: 6,
							},
							1700: {
								slidesPerView: 7,
							},
						}}
						modules={[Autoplay, FreeMode]}
						className='mySwiper'
					>
						{teamImgs?.map((item, index) => (
							<SwiperSlide key={`${index}-about-us-culture`}>
								{/* <Col md={3} lg={4}> */}
								<div className='w-100 h-100'>
									<Image src={item} alt='..' style={{ width: '100%', height: '100%' }} className='rounded-3 object-fit-cover' />
								</div>
								{/* </Col> */}
							</SwiperSlide>
						))}
					</Swiper>
				</Row>
			</Container>
		</div>
	)
}

export default MeetMetalbookTeam
